import * as tslib_1 from "tslib";
import findIndexByInstanceKey from './helpers/findIndexByInstanceKey';
import onAddOrUpdateRow from './helpers/onAddOrUpdateRow';
import setRowOperation from './helpers/setRowOperation';
import reloadTable from '../data-loading/reloadTable';
import removeRowsFromListViewStore from '../triage/removeRowsFromListViewStore';
import tryRemoveItemNormalizedBody from 'owa-mail-actions/lib/table-loading/tryRemoveItemNormalizedBody';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
import tombstoneOperations from 'owa-mail-list-tombstone';
import { lazyPrefetchRowInCache } from 'owa-mail-prefetch';
import { mailStore } from 'owa-mail-store';
import conversationCache from 'owa-mail-store/lib//store/conversationCache';
import { action, select } from 'satcheljs/lib/legacy';
/**
 * This class is responsible for handling the notifications.
 * onAddOrUpdateNotification for RowAdd and RowModify notification types
 * onDeleteNotification for RowDelete notification types
 * onReloadNotification for Reload notification type
 */
/**
 * This function handles rowAdd notifications.
 * @param row present in the notification payload
 * @param tableview for which notification has arrived
 * which we will insert the new conversation payload
 */
export var onAddRow = action('rowNotificationHandler.onAddRow')(function onAddRow(row, tableView) {
    // Increment table size
    tableView.totalRowsInView++;
    // Handle adding the row to store
    onAddOrUpdateRow(row, tableView);
});
/**
 * This function handles rowModified notifications.
 * @param row present in the notification payload
 * @param tableview for which notification has arrived
 * which we will insert the new conversation payload
 */
export var onUpdateRow = action('rowNotificationHandler.onUpdateRow')(function onUpdateRow(row, tableView) {
    // Handle adding the row to store
    onAddOrUpdateRow(row, tableView);
});
/**
 * This function handles RowDeleted notification.
 * @param row present in the notification payload
 * @param tableview for which notification has arrived
 */
export var onDeleteRow = action('rowNotificationHandler.onDeleteRow')(function onDeleteRow(row, tableView) {
    if (!row.InstanceKey) {
        // row being deleted should not have a null instance key
        throw new Error('onDeleteNotification: Row instanceKey should not be null');
    }
    // Decrement table size
    tableView.totalRowsInView--;
    // Remove the row
    var indexOfElement = findIndexByInstanceKey(row.InstanceKey, tableView);
    if (indexOfElement >= 0) {
        removeRowsFromListViewStore([row.InstanceKey], tableView);
        setRowOperation(tableView, 3 /* RowDelete */);
    }
    // Always remove from tombstone regardless of RemoveFromTombstoneCondition, as delete notification
    // supercedes all other reasons, so that we clean up the tombstone properly on delete
    tombstoneOperations.remove(row.InstanceKey, tableView.serverFolderId);
});
/**
 * This function handles the reload notificaitons
 * @param tableView for which the notificaiton has arrived
 * TBD - Revisit the reload table logic - https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/11800
 */
export var onReload = select({
    conversations: function () { return conversationCache; },
    items: function () { return mailStore.items; },
})(action('rowNotificationHandler.onReload')(function onReload(tableView, state) {
    clearRowDataUsedByReadingPane(tableView, state);
    // Reload the table
    reloadTable(tableView);
    // Clear all tombstone entries for folder when we get a reload notification. Reload notification generally
    // signals a disconnect between server and client, so we can no longer count on getting the delete notifications
    // to clear the tombstone list
    tombstoneOperations.clearMapForFolder(tableView.serverFolderId);
}));
function clearRowDataUsedByReadingPane(tableView, state) {
    var e_1, _a;
    var listViewType = tableView.tableQuery.listViewType;
    switch (listViewType) {
        case 0 /* Conversation */:
            // On reloads our cached conversations in the MRU cache would be in a stale state.
            // As we do not keep all the conversations in sync on reloads there are chances
            // that reading pane would show the stale conversation from the MRU cache.
            // We should therefore clear the MRU conversation cache whenever a reload happens.
            state.conversations.clear();
            // The cache might still hold on to the converations that are being referenced.
            // In that case we should try to prefetch them.
            // E.g: If user was viewing an item in reading pane when this happened,
            // that item will not be purged (cleared) and we would want to prefetch it.
            var remainingItemsInMRUCache = state.conversations.getItemIds();
            for (var i = 0, len = remainingItemsInMRUCache.length; i < len; i++) {
                var conversationItemParts = state.conversations.get(remainingItemsInMRUCache[i]);
                lazyPrefetchRowInCache.importAndExecute(conversationItemParts.conversationId, tableView);
            }
            break;
        case 1 /* Message */:
            try {
                for (var _b = tslib_1.__values(tableView.rowKeys), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var rowKey = _c.value;
                    var rowId = MailRowDataPropertyGetter.getRowClientItemId(rowKey, tableView);
                    var item = state.items.get(rowId.Id);
                    tryRemoveItemNormalizedBody(item);
                    // After we tried to remove normalized body, it might still exist in the cache because it’s held by RP,
                    // we need to refresh the item to get refresh data
                    if (state.items.get(rowId.Id).NormalizedBody) {
                        lazyPrefetchRowInCache.importAndExecute(rowId, tableView);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            break;
    }
}
//# sourceMappingURL=rowNotificationHandler.js.map